import { gql } from '../../../__generated__/graphql/catalog'

export const SEARCH = gql(`
  query Search($after: String, $first: Int!, $query: String!, $selectedFilters: [SearchFilterInput!]) {
    search(query: $query, selectedFilters: $selectedFilters) {
      suggestions {
        query
      }
      items(first: $first, after: $after) {
        nodes {
          product {
            ...CollectionItemProduct
            exclusive
          }
        }
        analyticsId
        pageInfo {
          endCursor
          hasNextPage
        }
        numItems
        colors {
          name
          hexCodes
        }
        filters {
          displayType
          displayName
          key
          filterValues {
            value
            state
          }
        }
      }
    }
  }
`)
